import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import { findCity } from "../../data/cities";

export const CityLocal = ({ city }) => {
  const neighbors = (city.nearby || [])
    .map(findCity)
    .filter(Boolean);

  return (
    <section
      data-testid="city-local-section"
      className="bg-[#F0ECE6] py-24 md:py-32 relative grain-light"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 md:gap-12">
          <div className="col-span-12 lg:col-span-7">
            <div className="text-[#C05746] text-xs md:text-sm font-semibold tracking-[0.24em] uppercase mb-4">
              Local conditions
            </div>
            <h2 className="font-display text-[#1C1B1A] text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight mb-8">
              Why {city.city} homes need
              <br />
              <span className="font-serif-accent italic text-[#C05746]">specific</span> attention.
            </h2>
            <ul className="space-y-5">
              {city.local.map((item, i) => (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="flex items-start gap-4 text-[#1C1B1A] text-base md:text-lg leading-relaxed"
                >
                  <CheckCircle2
                    size={20}
                    className="text-[#C05746] mt-1 flex-shrink-0"
                    strokeWidth={2}
                  />
                  <span>{item}</span>
                </motion.li>
              ))}
            </ul>
          </div>

          <aside className="col-span-12 lg:col-span-5">
            <div className="bg-[#F9F7F4] border border-[#E5DFD5] p-8 md:p-10">
              <div className="text-[10px] uppercase tracking-[0.24em] text-[#C05746] mb-4">
                Nearby service areas
              </div>
              <h3 className="font-display text-2xl md:text-3xl text-[#1C1B1A] tracking-tight mb-6">
                We also cover
              </h3>
              <ul className="divide-y divide-[#E5DFD5]">
                {neighbors.map((n) => (
                  <li key={n.slug}>
                    <Link
                      to={`/service-areas/${n.slug}`}
                      className="group flex items-center justify-between py-4 hover:text-[#C05746] transition-colors"
                      data-testid={`nearby-link-${n.slug}`}
                    >
                      <span className="font-display text-lg md:text-xl">
                        {n.city}, {n.stateCode}
                      </span>
                      <ArrowUpRight
                        size={18}
                        className="opacity-50 group-hover:opacity-100 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                      />
                    </Link>
                  </li>
                ))}
                <li>
                  <Link
                    to="/#areas"
                    className="group flex items-center justify-between py-4 text-[#5C5A55] hover:text-[#C05746] transition-colors"
                  >
                    <span className="text-sm uppercase tracking-[0.16em]">
                      See all 16 service areas
                    </span>
                    <ArrowUpRight size={16} />
                  </Link>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};
